// Chakra imports
// Chakra imports
import {
    Flex,
    useColorModeValue,
    Text, Icon,
    Button,
    useDisclosure
} from "@chakra-ui/react";

// Custom components
import Card from "components/card/Card.js";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalFooter,
    ModalBody,
} from '@chakra-ui/react'
import React, {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import {HiQuestionMarkCircle} from "react-icons/hi";
import {HiHeart } from "react-icons/hi";
import {LogEvent} from "../../analytics/analytics";
import ReactSession from "../../utils/ReactSession";

export default function TransfersBalanceCard(props) {
    const { details,  callBack} = props;

    const { t , i18n} = useTranslation();
    // name='זמין למשיכה' value='₪1291'
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const brandColor = useColorModeValue("brand.500", "white");
    const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
    const textColorSecondary = "secondaryGray.900";
    const title = t('main_card_2_title');
    const subtitleFontSize = '18px'
    const margin = '15px'
    const availableToTransfer =  details.availableToTransfer ? details.availableToTransfer : 0;
    const availableToTransferText = availableToTransfer+ " ₪";
    const totalTransferred = details.totalTransferred ? details.totalTransferred : 0;
    const totalTransfersMonth = t('main_card_2_bottom') + t('nis_symbol') + totalTransferred;
    const [ blurText, setBlurText] = useState(true);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const key = "transfers_available_info1"
    useEffect(() => {
        const shouldBlur = false; //ReactSession.get(key) !== "1"
        setBlurText(shouldBlur)
    }, []);

    const handleAlertApprove = () => {
        onClose()
        ReactSession.set(key, "1");
        setBlurText(false)
    }

    const handleCardClick = () => {
        onOpen()
    }

    const onInformationClicked = () => {
        LogEvent("balance_i_click")
        onOpen()
    }

    const onButtonClick = () => {
        const shouldBlur = ReactSession.get(key) !== "1"
        if(shouldBlur) {
            handleCardClick();
        } else {
            callBack();
        }
    }

    const blurStyles = blurText === true ? {
        'transition': 'filter 400ms',
        '-webkit-filter': 'blur(15px)',
        'filter': 'blur(15px)'
    } : {} ;

    return (
        <Card>
            <Flex
                flexDirection={'column'}
                alignItems={'right'}
                my='auto'
                h='100%'>

                <Flex onClick={handleCardClick}
                      flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}
                >
                    <Text
                        lineHeight='100%'
                        color={textColorSecondary}
                        fontSize={subtitleFontSize}>
                        {title}
                    </Text>

                    {/*<Icon*/}
                    {/*    as={HiQuestionMarkCircle}*/}
                    {/*    w='30px'*/}
                    {/*    h='30px'*/}
                    {/*    onClick={onInformationClicked}*/}
                    {/*    style={blurStyles}*/}
                    {/*    color={'brand.500'} />*/}
                </Flex>

                { blurText && <Button style={{position: "absolute", marginRight: "auto", marginLeft:"auto", marginTop:"50px", left: "40px", right: "40px"}}
                                      variant={"brand"}  onClick={handleCardClick}
                                      textColor={'white'}>{t('click_here_button')}</Button>
                }


                <Flex mt={margin} flexDirection={'row'} justifyContent={'space-between'}
                      >
                    <Text
                        lineHeight='100%'
                        color={textColorSecondary}
                        fontSize={'40px'}
                        fontWeight={'bold'}
                        style={blurStyles}
                        onClick={handleCardClick}
                        >
                        {availableToTransferText}
                    </Text>
                    {/*<Button*/}
                    {/*    _hover={brandColor}*/}
                    {/*    onClick={onButtonClick}*/}
                    {/*    textColor='white'*/}
                    {/*    fontSize={'12px'}*/}
                    {/*    style={blurStyles}*/}
                    {/*    backgroundColor={brandColor}>*/}
                    {/*    {t('main_card_2_button')}*/}
                    {/*</Button>*/}
                </Flex>
                <Text
                    mt={margin}
                    lineHeight='100%'
                    color={textColorSecondary}
                    fontSize={subtitleFontSize}
                    style={blurStyles}
                    onClick={handleCardClick}
                    fontWeight='400'>
                    {totalTransfersMonth}
                </Text>

                <Flex ms='auto'>

                    <Modal
                        isOpen={isOpen}
                        onClose={onClose}
                        isCentered>
                        <ModalOverlay />
                        <ModalContent maxW="350px">
                            <ModalBody>
                                <Flex marginTop={'10px'}
                                      flexDirection={'row'}
                                      justifyContent={'center'}
                                      alignItems={'center'}
                                      align={'center'} >
                                    <Text fontWeight='bold' fontSize={'35px'}>
                                        {t('earnings_prompt_title')}
                                    </Text>
                                    <Icon
                                        margin={'10px'}
                                        as={HiHeart}
                                        w='40px'
                                        h='40px'
                                        onClick={onInformationClicked}
                                        color={'red'} />
                                </Flex>

                                <Flex marginTop={'10px'} flexDirection={'column'}>
                                    <Text fontSize={'20px'}>
                                        {t('balance_prompt_message_1_1')} <strong>{t('earnings_prompt_message_1_2')}</strong> {t('earnings_prompt_message_1_3')}
                                    </Text>
                                    <Text margin={'10px'} fontSize={'20px'}>{t('balance_prompt_message_2')}</Text>
                                    <Text margin={'10px'} fontSize={'20px'}>{t('balance_prompt_message_3')}</Text>
                                    <Text margin={'10px'} fontSize={'20px'}>{t('balance_prompt_message_4')}</Text>
                                </Flex>
                            </ModalBody>

                            <ModalFooter>
                                <Button fontSize={'22px'} variant={"brand"} onClick={handleAlertApprove}>{t('earnings_prompt_confirm_button')}</Button>
                            </ModalFooter>
                        </ModalContent>
                    </Modal>


                </Flex>
            </Flex>
        </Card>
    );
}
